import {
  Box,
  Flex,
  HStack,
  Text,
  Image,
  Divider,
  IconButton,
  useDisclosure,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useToast
} from "@chakra-ui/react";
import smrImage1 from "@/assets/images/smr_img1.png";
import { RiNotification4Fill } from "@remixicon/react";
import MessageMenu from "@/components/layout/header/messagemenu";
import { useSelector } from "react-redux";
import { selectUnReadMsSystemNum, selectUser, updateUnReadMsSystemNum } from "@/reducer/userslice";
import { useState, useEffect } from "react";
import PersonalMenu from "../layout/header/personalmenu";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import loginbg from "@/assets/loginbg.png";
import { LoginForm, UserProfile } from "@/types/user";
import Login from "../login";
import { useLocation } from "react-router-dom";
import { login } from "@/services/api/thunks/users";
import { useLazyWxtokenQuery } from "@/services/api/endpoints/wxlogin";
import PayCenterModal from "@/components/payCenterModal";
import { useLazyGetMsCountQuery } from "@/services/api/endpoints/mssystem";
import {v4 as uuidv4} from 'uuid';

const SmrHeader = () => {
  const user = useSelector(selectUser);
  const toast = useToast();
  const location = useLocation();
  const [wxtoken] = useLazyWxtokenQuery();
  const dispatch = useAppDispatch();
  const [menuOpen, setMenuOpen] = useState(false);
  const PayControl = useDisclosure();
  const messageControl = useDisclosure();
  const loginDisclosure = useDisclosure();
  const [binding, setBinding] = useState(true);
  const [loginBy, setLoginBy] = useState(0);
  const [wxuser, setWxUser] = useState<UserProfile>();
  const params = new URLSearchParams(window.location.search);

  // 未读系统消息数
  const unReadMsSystemNumn = useAppSelector(selectUnReadMsSystemNum);
  const [getMsCount] =  useLazyGetMsCountQuery();
  const openMenu = () => setMenuOpen(true);
  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
   
    (async () => {
      const result = await getMsCount({})
      dispatch(updateUnReadMsSystemNum(result.data!))
    })();
    // 创建 WebSocket 连接
    const hostname = window.location.hostname=="localhost"?"192.168.1.6:8065":window.location.hostname;
    const connect_id= uuidv4();
    const webSocket = new WebSocket(`//${hostname}/api/v4/mssystem/ws?connect_id${connect_id}`);

    webSocket.onopen = () => {
      console.log('WebSocket连接已建立');
      webSocket.send(JSON.stringify("mssystem"));
    };

    webSocket.onmessage = (event) => {
      console.log(event.data)
      dispatch(updateUnReadMsSystemNum(event.data))
      // setMessages(event.data);
    };

    webSocket.onerror = (error) => {
      console.error('WebSocket错误:', error);
    };

    webSocket.onclose = () => {
      console.log('WebSocket连接已关闭');
    };
    // 清理函数，组件卸载时关闭 WebSocket 连接
    return () => {
      webSocket.close();
    };
  }, []);

  const handLoginOrSignUp = async () => {
    setLoginBy(0);
    loginDisclosure.onOpen();
  };

  useEffect(() => {
    const handleWxLogin = async () => {
      if (params.get("code")) {
        const result = await wxtoken({ code: params.get("code")! }).unwrap();
        if (result.phone) {
          const form = { union_id: result.unionid } as LoginForm;
          const loginResult = await dispatch(login(form));
          if (loginResult.type == "users/login/fulfilled") {
            loginDisclosure.onClose();
          }
        } else {
          setWxUser(result);
          setBinding(false);
          setLoginBy(2);
          loginDisclosure.onOpen();
        }
      }
    };
    handleWxLogin();
  }, []);

  //   充值会员
  const handleRechargeMembership = () => {
    PayControl.onOpen();
  };

  const handleOpenMessage = () => {
    if (user && user.id) {
      messageControl.onOpen();
    } else {
      toast({
        title: "请登录系统",
        position: "top",
        status: "error",
        duration: 1000,
      });
    }
  }

  return (
    <Flex h="60px" mb="10px" boxSizing="border-box" justifyContent="space-between" pl="25px" pr="25px" border="1px solid #6C7596">
      <HStack spacing={"30px"}>
        <Box
          w="80px"
          h="36px"
          borderRadius={"61px"}
          textAlign="center"
          lineHeight={"36px"}
          bg="#1E253F"
          color={"#FFFFFF"}
          fontSize="14px"
        >
          工作台
        </Box>
        <Text color={"#FFFFFF"} fontSize="20px" fontWeight={"bold"}>
          毛坯房精装
        </Text>
      </HStack>

      <HStack>
        <Flex
        mr="25px"
          h="36px"
          pl="20px"
          pr="20px"
          borderRadius={"61px"}
          textAlign="center"
          lineHeight={"36px"}
          bg="#1E253F"
          color={"#FFFFFF"}
          fontSize="14px"
          alignItems={"center"}
          onClick={handleRechargeMembership}
        >
          <Image mr="10px" boxSize={"16px"} src={smrImage1} />
          <Text
            sx={{
              bgGradient: "linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)",
              backgroundClip: "text",
              webkitBackgroundClip: "text",
            }}
          >
            {user.totalcoin || 0}
          </Text>
          <Divider
            ml="15px"
            mr="15px"
            orientation="vertical"
            h="13px"
            color={"#6C7596"}
          />
          <Text>开会员，得积分</Text>
        </Flex>

        <Box>
          <Box position={"relative"} mr="25px">
            <IconButton
              aria-label="message"
              w="22px"
              minW={"22px"}
              icon={<RiNotification4Fill size={"22px"} color="#a0aec0" />}
              cursor={"pointer"}
              onClick={handleOpenMessage}
              variant="unstyled"
            />
            {unReadMsSystemNumn > 0 && (
              <Box
                position="absolute"
                top="2px"
                right="-12px"
                height="14px"
                width="14px"
                bg={"#ff0000"}
                color="#fff"
                fontSize={"8px"}
                textAlign="center"
                lineHeight={"14px"}
                borderRadius="50%"
              >
                {unReadMsSystemNumn}
              </Box>
            )}
          </Box>

          <MessageMenu
            isOpen={messageControl.isOpen}
            onClose={messageControl.onClose}
          />
        </Box>
        <Box>
          {user?.id ? (
            <PersonalMenu
              menuOpen={menuOpen}
              openMenu={openMenu}
              closeMenu={closeMenu}
            />
          ) : (
            <Box>
              <Button
                className="loginBtn"
                onClick={handLoginOrSignUp}
                _hover={{ bg: "none" }}
                bg="#1E253F"
                color={"#FFFFFF"}
                fontSize="14px"
              >
                登录/注册
              </Button>
              <Modal
                isOpen={loginDisclosure.isOpen}
                onClose={loginDisclosure.onClose}
                size="full"
              >
                <ModalOverlay />
                <ModalContent
                  sx={{
                    backgroundImage: `url(${loginbg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  <ModalHeader></ModalHeader>
                  <ModalCloseButton />
                  <ModalBody>
                    <Login
                      binding={binding}
                      wxuser={wxuser!}
                      loginBy={loginBy}
                      handleLoginBy={setLoginBy}
                      onClose={loginDisclosure.onClose}
                    />
                  </ModalBody>
                </ModalContent>
              </Modal>
            </Box>
          )}
        </Box>
      </HStack>
      <PayCenterModal
        tabIndex={0}
        isOpen={PayControl.isOpen}
        onClose={PayControl.onClose}
      />
    </Flex>
  );
};

export default SmrHeader;
